import React from "react";
import { Normalize } from "styled-normalize";
import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  html {
    height:100%;
    overflow-x: hidden;
  }

  body {
    height:100%;
    margin: 0;
    /* The theme's own global styles set the base type on #root, which portalled
       UI (tooltips, dialogs, popovers, menus) sits outside — it would inherit the
       browser's 16px default instead. Setting it on body covers both. */
    ${({ theme }) => theme.typography.body1};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    /* react-toastify defaults this to the generic sans-serif. */
    --toastify-font-family: ${({ theme }) => theme.colors.fonts.primary};
  }

  /* Form controls don't inherit type by default and the reset doesn't list
     them, so they would otherwise fall back to the browser's UI font. */
  input,
  select,
  textarea,
  button {
    font-family: inherit;
  }

  #root {
    height:100%;
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
      monospace;
  }

  * {
    scrollbar-color: ${({ theme }) => theme.colors.bg.divider} transparent;

    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      border-radius: 3px;
    }

    &::-webkit-scrollbar-track {
      background-color: transparent;
      border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: ${({ theme }) => theme.colors.bg.divider};
      border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background-color: ${({ theme }) => theme.colors.fg.tertiary};
    }
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(359deg); }
  }

  @keyframes pulsate {
    0%   { opacity: 0; }
    50%   { opacity: 1; }
    100% { opacity: 0; }
  }

  @keyframes tableHighlight {
    0%   { opacity: 0; }
    50%   { opacity: 0.4; }
    100% { opacity: 0; }
  }
`;

// The only call site is `App.tsx`, which passes nothing — the theme reaches `GlobalStyle`
// through the provider, not through props, so the spread this used to forward was always empty.
const GlobalCSS = () => (
  <>
    <Normalize />
    <GlobalStyle />
  </>
);

export default GlobalCSS;
